import React, { useEffect, useState } from 'react';
import { dossierAPI } from '../../api/traceability';
import { STAGES } from '../../lib/traceability';

// #Fase3-G10 — No deduce pendientes con enlaces legacy; consulta el cierre solo cuando se solicita.
export default function EventTraceabilityStatus({ event }) {
  const [ready, setReady] = useState(event.audit_ready);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  useEffect(() => { setReady(event.audit_ready); }, [event.id, event.updated_at, event.audit_ready]);
  const consult = async (e) => {
    e.stopPropagation();
    setBusy(true);
    try {
      setReady((await dossierAPI.get(event.id)).data.audit_ready);
      setError('');
    } catch {
      setError('No se pudo consultar el cierre');
    } finally {
      setBusy(false);
    }
  };
  return <span className="text-xs text-slate-600">
    {STAGES[event.stage] && <span>Etapa: {STAGES[event.stage]} · </span>}
    {typeof ready === 'boolean' ? (
      <span>{ready ? 'Listo para auditar' : 'Cierre pendiente en el expediente'}</span>
    ) : <button type="button" disabled={busy} onClick={consult}>Consultar cierre del expediente</button>}
    {error && <span role="alert">{error}</span>}
  </span>;
}
